<div class="seller-details">
    <!-- Loading State -->
    <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading</span>
        </div>
    </div>

    <!-- Seller Details -->
    <div *ngIf="!loading && seller">
        <!-- Header with Status and Actions -->
        <div class="d-flex justify-content-between align-items-center mb-4">
            <div>
                <h3 class="mb-2">
                    <span *ngIf="isCompanySeller()">Company Seller</span>
                    <span *ngIf="isPrivateSeller()">Private Seller</span>
                </h3>
                <span [ngClass]="getStatusClass()">
                    {{ seller.status }}
                </span>
            </div>
            <div class="d-flex gap-2">
                <button class="btn btn-outline-secondary" (click)="goBack()">
                    Back
                </button>
                <button class="btn btn-success" *ngIf="canApprove()" (click)="openApproveConfirmation(approveModal)">
                    Approve
                </button>
                <button class="btn btn-danger" *ngIf="canReject()" (click)="openRejectModal()">
                    Reject
                </button>
            </div>
        </div>

        <!-- Company Seller Details -->
        <app-company-seller-detail 
            *ngIf="isCompanySeller()" 
            [seller]="seller">
        </app-company-seller-detail>

        <!-- Private Seller Details -->
        <app-private-seller-detail 
            *ngIf="isPrivateSeller()" 
            [seller]="seller">
        </app-private-seller-detail>
    </div>
</div>

<!-- Approve Confirmation Modal -->
<ng-template #approveModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Confirm Approval</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p>Are you sure you want to approve this seller account?</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">
            Cancel
        </button>
        <button type="button" class="btn btn-success" (click)="confirmApprove()">
            Confirm Approval
        </button>
    </div>
</ng-template>
